import TagManager from "react-gtm-module";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import {useAppConfig} from "@ct-react/core";
import { useEffect, useState } from "react";

const CookieProvider = () => {

  const { env, gaTag: gtmId } = useAppConfig()
  const { consent: { thirdParty } } = useCookieConsentContext();

  const [ inited, setInited ] = useState<boolean>(false);

  useEffect(() => {
    if (!gtmId || inited || !thirdParty) return;
    TagManager.initialize({ gtmId });
    setInited(true);
  }, [ thirdParty ]);

  return null;

}

export default CookieProvider;
